import { Filter, Line } from "@components/Filters/Filter"
import { FilterToggle } from "@components/Filters/Toggle"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import React from "react"
import { articleFilters } from "./filterOptions"
import FilterContainer from "@components/Filters/FilterContainer"
import { getSizeLabel } from "./helpers/get-size-label"

interface Props {
  style: string
  size: string | null
  fixedFilters: {
    [key: string]: string[]
  }
  uid: string
  hasMoreFilters: boolean
  onToggleSidebar: () => void
  onToggleStyle: (style: string) => void
  onToggleSize: (size: string) => void
  hasMoreFiltersSet: boolean
}

const Filters: React.FC<Props> = ({
  style,
  size,
  fixedFilters,
  uid,
  onToggleSidebar,
  onToggleStyle,
  onToggleSize,
  hasMoreFilters,
  hasMoreFiltersSet,
}) => {
  const { messages } = useIntl()
  let sizeFilters =
    fixedFilters &&
    fixedFilters["size"] &&
    // filter out empty ones and check if there are more than one
    fixedFilters["size"].filter((v) => v).length > 1
      ? fixedFilters["size"].map((key) =>
          messages.properties.size.options[key] ? (
            <Filter
              status={size === key ? "active" : "idle"}
              key={key}
              onClick={() => onToggleSize(key)}
              icon={key as string}
            >
              {getSizeLabel(style, key)}
            </Filter>
          ) : null
        )
      : null

  if (sizeFilters) {
    sizeFilters = sizeFilters.reverse()
  }

  return (
    <FilterContainer
      display="flex"
      justifyContent={["flex-start", "space-between"]}
      mb={4}
      pb={[4, 2]}
      mt={2}
    >
      <Box display="flex">
        {articleFilters[uid].map((key) => (
          <Filter
            status={style === key ? "active" : "idle"}
            key={key}
            onClick={() => onToggleStyle(key)}
            icon={key as string}
          >
            {messages.properties.style.options[key]}
          </Filter>
        ))}
        <Line />
        {sizeFilters}
        <Line display={["block", "none"]} />
      </Box>
      {hasMoreFilters && (
        <FilterToggle active={hasMoreFiltersSet} onClick={onToggleSidebar}>
          {messages.collectionDetail.moreFilters}
        </FilterToggle>
      )}
    </FilterContainer>
  )
}

export default Filters
